import { UntypedFormControl } from '@angular/forms';
import { UntypedFormGroup } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { toUTCDate } from 'src/app/functions/shared-functions';

@Component({
  selector: 'tm-date-time-picker-t2',
  templateUrl: './date-time-picker-t2.component.html',
  styleUrls: ['./date-time-picker-t2.component.scss']
})
export class DateTimePickerT2Component implements OnInit, OnDestroy, OnChanges {

  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Output() getValue = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Input() field;
  @Input() minValue;
  @Input() maxValue;
  @Input() disabled;
  @Input() label_class;
  @Input() label_width;
  @Input() label_css;
  @Input() control_width;
  @Input() control_class;
  @Input() control_css;
  @Input() design_pattern;
  @Input() hide_label;
  @Input() label_overflow;
  @Input() suffix_settings;

  subscription: Subscription;
  prev_value;
  date = new UntypedFormControl();

  picker_open_flag = 1;
  @ViewChild('picker', { static: false }) picker;
  random_id = 'date_time_picker' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  constructor() { }

  ngOnInit() {

    if (this.form.get(this.controlName).value) {

      this.date.setValue(toUTCDate(this.form.get(this.controlName).value));
    }
    else if (this.form.get(this.controlName).value && this.form.get(this.controlName).value.indexOf('1900') > -1) {
      this.form.get(this.controlName).patchValue(null)
    }

    this.subscription = this.form.get(this.controlName).valueChanges.subscribe(res => {
      try {
        if (this.form.get(this.controlName).value) {
          if (this.form.get(this.controlName).value.indexOf('1900') > -1) {
            this.form.get(this.controlName).setValue(null);
          }

        }
      }
      catch (err) { }

      if (res && res != this.prev_value) {
        this.prev_value = res;
        if (this.form.get(this.controlName).value) {
          this.date.setValue(toUTCDate(this.form.get(this.controlName).value));
          let data = new Date(this.form.get(this.controlName).value).toUTCString();
          this.onChange.emit({ value: moment.parseZone(data).format('YYYY-MM-DD HH:mm:ss') });
        }
        else {
          this.date.reset()
        }
      }
      if (!res) {
        this.date.reset()
      }
    })
  }
  ngOnChanges(ev) {

    //
    if (ev && ev.minValue) {
      this.minValue = new Date(ev.minValue.currentValue)
    }
    if (ev && ev.value) {
      this.value = ev.value.currentValue;
      if (this.value && this.value != '') {
        let dada = new Date(this.value + ' UTC')
        this.date.patchValue(new Date(dada));
        // this.form.controls[this.controlName].patchValue(this.data);
      }
      else {
        this.date.reset();
      }
    }
    if (ev && ev.disabled) {
      this.disabled = ev.disabled.currentValue;
      if (this.disabled) {
        this.date.disable()
      }
      else {
        this.date.enable();
      }
    }

  }

  ngOnDestroy(): void {
    if (this.subscription && this.subscription.unsubscribe) {
      this.subscription.unsubscribe();
    }

  }

  addEvent(ev) {
    let data = new Date(ev.value).toUTCString();
    this.form.get(this.controlName).setValue(moment.parseZone(data).format('YYYY-MM-DD HH:mm:ss'));
    this.getValue.emit(data);
    this.onChange.emit({ value: moment.parseZone(data).format('YYYY-MM-DD HH:mm:ss') });
  }
  anc(evt) {
    console.log(new Date(evt))
  }
  removeDate(ev) {
    ev.preventDefault();
    this.form.get(this.controlName).reset();
    this.date.reset();
  }

  openPicker(open_flag) {
    if (open_flag && !this.disabled) {
      setTimeout(() => {
        this.picker.open();
      })
    }
  }

  suffixClicked() {
    if (this.suffix_settings && this.suffix_settings.func) {
      try {
        this.suffix_settings.func()
      }
      catch (err) {
        console.log(err)
      }
    }
  }
}
